<template>
  <div class="menu-btns" v-click-outside="hideMenu">
    <div class="menu-btns-toggle" :class="[isShow ? 'active' : '']" @click="toggleMenu">
      <span class="btn-main">{{ $t('세일즈') }}</span>
      <font-awesome-icon :icon="['fas', isShow ? 'caret-up' : 'caret-down']" />
    </div>

    <transition name="fade">
      <div class="menu-popover" v-if="isShow">
        <ul>
          <li>
            <button @click="handleMoveSolution('sales')" :title="$t('세일즈로 이동')">
              {{ $t('세일즈') }}
            </button>
          </li>
          <li>
            <button @click="handleMoveSolution('sales_admin')" :title="$t('세일즈 관리로 이동')">
              {{ $t('세일즈 관리') }}
            </button>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
import { moveToSolution } from '@/js/moveToSolution';
import { mapState } from 'vuex';

export default {
  name: 'SalesMenu',
  props: {},
  data() {
    return {
      isShow: false,
      hrLink: process.env.VUE_APP_ERP_HR,
      accountingLink: process.env.VUE_APP_ERP_ACCOUNTING,
      billLink: process.env.VUE_APP_ERP_BILL,
    };
  },
  computed: {
    ...mapState({
      platformMenuAccess: (state) => state.menu.platformMenuAccess,
    }),
  },
  methods: {
    toggleMenu() {
      this.isShow = !this.isShow;
    },

    hideMenu() {
      this.isShow = false;
    },

    async handleMoveSolution(toSolution) {
      let authResult = {};
      if (!this.platformMenuAccess) {
        try {
          authResult = await this.$store.dispatch('menu/loadPlatformAccessAuth');
        } catch (error) {
          console.error(error);
          alert('일시적인 오류로 인해 이동을 할 수 없습니다. 새로고침을 하여 다시시도해주세요.');
          return;
        }
      } else {
        authResult = this.platformMenuAccess;
      }

      moveToSolution(toSolution, authResult, this.domain);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/base/variables.scss';

.menu-btns {
  .menu-btns-toggle {
    display: flex;
    align-items: center;
    line-height: 38px;
    cursor: pointer;

    .btn-main {
      -webkit-touch-callout: none; /* iOS Safari */
      -webkit-user-select: none; /* Safari */
      -khtml-user-select: none; /* Konqueror HTML */
      -moz-user-select: none; /* Old versions of Firefox */
      -ms-user-select: none; /* Internet Explorer/Edge */
      user-select: none; /* Non-prefixed version, currently
                            supported by Chrome, Edge, Opera and Firefox */
      color: #454545;
      font-size: 18px;
      letter-spacing: -1px;
      font-weight: 500;
      margin-right: 10px;
    }
    .fa-caret-down {
      color: #909090;
      font-size: 18px;
    }
    .fa-caret-up {
      color: #909090;
      font-size: 18px;
    }
  }

  .gi-exclam-circle {
    color: #d75251;
    cursor: pointer;
  }

  .arrow_box {
    position: relative;
    background: #e6e6e6;
    //height: 42px;
    width: 536px;
    border-radius: 4px;
    font-size: 14px;
    color: #c70909;
    padding: 10px;
    left: 10px;
  }
  .arrow_box:after,
  .arrow_box:before {
    right: 100%;
    top: 50%;
    border: solid transparent;
    content: '';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  .arrow_box:after {
    border-color: rgba(136, 183, 213, 0);
    border-right-color: #e6e6e6;
    border-width: 3px;
    margin-top: -3px;
  }
  .arrow_box:before {
    border-color: rgba(245, 245, 245, 0);
    border-right-color: #e6e6e6;
    border-width: 6px;
    margin-top: -6px;
  }

  .menu-popover {
    position: absolute;
    width: 140px;
    top: $managementHeaderHeight;
    left: 20px;
    padding: 0;
    background: #fff;
    border: solid 1px #909090;
    border-radius: 4px;
    box-shadow: 2px 5px 4px 0 rgba(0, 0, 0, 0.16);
    overflow: auto;

    ul {
      padding: 8px 0;

      li {
        display: flex;
        align-items: center;
        height: 34px;
        padding: 8px 16px;
        font-size: 13px;
        cursor: pointer;

        button {
          width: 100%;
          text-align: left;
        }

        &:hover {
          background-color: rgba(190, 198, 204, 0.2);
        }
      }
    }
  }
}
</style>
